import React, {Component, useEffect, useState} from "react";
import {Select, Row, Col, Button, Space, Form, Input} from "antd";
import "./FormInput2.scss";

import TableInput from "./components/TableInput/TableInput";
const {TextArea} = Input;
const FormInput2 = props => {
  const {catalog, formRef, childrenName} = props;
  const {name, components, title} = catalog;
  const [objects, setObjects] = useState<any>();
  useEffect(() => {
    setShowInit();
  }, [catalog, formRef, childrenName]);

  const setShow = index => {
    objects[index].show = !objects[index].show;
    const newObjects = [...objects];
    setObjects(newObjects);
  };
  useEffect(() => {}, [objects]);
  // console.log(objects);
  const setShowInit = () => {
    var newObjects = catalog.objects.map(object => {
      var result = {...object, show: false};
      object.components.forEach(component => {
        const pathValue =
          childrenName.length > 0
            ? [...childrenName, catalog.name, object.name, component.name]
            : [catalog.name, object.name, component.name];
        const value = formRef.current.getFieldValue(pathValue);
        if (value && value.length > 0) {
          result.show = true;
        }
      });
      return result;
    });

    setObjects(newObjects);
  };

  return (
    <div className="form-input-2">
      {objects && (
        <Space direction="vertical" size={"small"} style={{width: "100%"}}>
          <div className="form-input-name">{title}</div>
          <Space wrap={true}>
            {objects.map((object, index) => (
              <div key={index}>
                <Space>
                  <Button
                    onClick={() => setShow(index)}
                    type={object.show ? "primary" : "default"}
                  >
                    {object.title}
                  </Button>
                </Space>
              </div>
            ))}
          </Space>
          {objects.filter(e => e.show == true).length > 0 ? (
            <TableInput
              formRef={formRef}
              objectsShow={objects.filter(e => e.show == true)}
              catalog={catalog}
              components={components}
              childrenName={childrenName}
            />
          ) : null}

          <Row className="default-objects" gutter={[16, 16]}>
            {catalog.defaultObjects.map((e, index) => (
              <Col key={index} xs={12} md={12} lg={12} xl={e?.xl ?? 8}>
                <Form.Item label={e.label} name={[catalog.name, e.name]}>
                  {e.type == "input" && <Input placeholder="Nhập"></Input>}
                  {e.type == "textArea" && (
                    <TextArea placeholder="Nhập" rows={e?.row ?? 2}></TextArea>
                  )}
                </Form.Item>
              </Col>
            ))}
          </Row>
        </Space>
      )}
    </div>
  );
};
export default FormInput2;
